export default __webpack_public_path__ + "static/game-intro-06-b608fa06cf0b5f35d2baeb736f0200ab.png";